import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import MonoButton from "../components/MonoButton";

const ResetPassword = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [token, setToken] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [message, setMessage] = useState("");
  const [success, setSuccess] = useState(false);

  // Token aus URL extrahieren
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const urlToken = params.get("token");
    if (!urlToken) {
      setMessage("Kein gültiger Reset-Link.");
    } else {
      setToken(urlToken);
    }
  }, [location]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage("");

    try {
      const response = await fetch("https://www.denisbitter.de/stage01/api/reset_password.php", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ token, newPassword }),
      });

      const data = await response.json();
      if (data.success) {
        setSuccess(true);
        setTimeout(() => navigate("/login"), 3000); // Weiterleitung
      } else {
        setMessage(data.message || "Fehler beim Zurücksetzen.");
      }
    } catch (error) {
      setMessage("Server nicht erreichbar.");
    }
  };

  return (
    
    <div className="max-w-md mx-auto p-6 mt-10 bg-white shadow-md rounded font-mono">
      <p className="text-xs text-gray-500 italic">
  Du musst dein initiales Passwort einmal ändern, bevor du fortfahren kannst.
</p>

      <h2 className="text-2xl font-bold mb-4">Neues Passwort setzen</h2>
      {message && <p className="text-red-500 text-sm mb-4">{message}</p>}
      {success ? (
        <p className="text-green-600">Passwort wurde erfolgreich geändert. Weiterleitung zum Login...</p>
      ) : (
        <form onSubmit={handleSubmit} className="space-y-4">
          <input
            type="password"
            placeholder="Neues Passwort mind. 8 Zeichen"
            className="w-full px-4 py-2 border rounded"
            value={newPassword}
            onChange={(e) => setNewPassword(e.target.value)}
            required
          />
          <MonoButton type="submit" className="w-full">
            Passwort speichern
          </MonoButton>
        </form>
      )}
    </div>
  );
};

export default ResetPassword;
